import { schema } from "normalizr";
import segmentSchema from "./segment";
import { WEVO_AUDIENCE_DELIMITER } from "../modules/audiences/constants";

const wevoAudienceSegmentSchema = new schema.Entity(
    "wevoSegments",
    {
        segment: segmentSchema
    },
    {
        idAttribute: value => {
            return [
                value.wevoId,
                value.segment.audienceId,
                value.segment.id
            ].join(WEVO_AUDIENCE_DELIMITER);
        }
    }
);

export default wevoAudienceSegmentSchema;



// WEBPACK FOOTER //
// ./src/schemas/wevo-audience-segment.js